module.exports = __webpack_public_path__ + "img/edit.81df6ef2.png";